import React, { useMemo, useContext } from "react";
import {
  Checkbox,
} from "antd";
import { isSafari } from "react-device-detect";
import { getUser } from "../../../../../utils/helpers";
import { ChemBioPendingContext } from "../../ChemBioPendingContext";

const PendingTableHeader = () => {
  const {
    loading,
    enableExtractedColumn,
    selectedGenerate,
    chemDropdown,
    chemColumns,
    bioChemColumns,
    handleExtractedColumnSelectAll,
  } = useContext(ChemBioPendingContext);

  const getTargetColumns = useMemo(() => {
    const targetCols = chemDropdown ? chemColumns : bioChemColumns;
    const user = getUser();
    const authorizedColumns = targetCols.reduce((acc, item) => {
      const { permission } = item;
      if (permission === "no-permission" || user.permissionMap[permission]) {
        acc.push(item);
      }
      return acc;
    }, []);
    return authorizedColumns;
  }, [chemColumns, bioChemColumns, chemDropdown]);

  let tableHeaderType = loading ? "--Loading" : (chemDropdown ? "--Chem" : ""); // eslint-disable-line
  if (loading) {
    tableHeaderType = "--Loading";
  } else if (chemDropdown) {
    tableHeaderType = isSafari ? "--ChemSafari" : "--Chem";
  }
  return (
    <thead>
      <tr className={`PendingTable__Heading${tableHeaderType}`}>
        {getTargetColumns.map((item, i) => (
          <td
            className={item.name.toLowerCase().includes("genista") ? "PendingTableGenistaCol" : ""}
            key={i}
          >
            {enableExtractedColumn && item.enableGenerate
    && (
    <Checkbox
      className="PendingTable__SelectAll"
      disabled={loading || selectedGenerate.get(`${item.sample_status}Count`) === 0}
      onChange={(e) => handleExtractedColumnSelectAll(e, item.sample_status)}
      checked={selectedGenerate.get(item.sample_status).size > 0 && selectedGenerate.get(`${item.sample_status}Count`) === selectedGenerate.get(item.sample_status).size}
    />
    )}
            {" "}
            {item.name}
          </td>
        ))}
      </tr>
    </thead>
  );
};

export default PendingTableHeader;
